var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" ID: "+_vm._s(this.user.uuid)),_c('br'),_vm._v(" "+_vm._s(this.user.name)+" "+_vm._s(this.user.surname)),_c('br'),_vm._v(" "+_vm._s(this.user.email)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }